export default "__VITE_ASSET__Bdj3D8gY__"